import Badge, { BadgeProps } from '@mui/material/Badge';
import Feature, { FeatureKey } from '../../shared/models/Feature';
import React, { ChangeEvent, useEffect, useState } from 'react';
import { cloneDeep, isFunction } from 'lodash';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { styled } from '@mui/system';
import { useLearnerCollections } from '../../content/hooks/useLearnerCollections';

interface NavigationProps {
  orientation: 'horizontal' | 'vertical';
  features: Feature[];
  selectedFeature: FeatureKey;
  numNotifications: number;
  onNavigate: (value: FeatureKey) => void;
}

const Navigation = (props: NavigationProps) => {
  const [selectedFeature, setSelectedFeature] = useState<FeatureKey>(
    props.selectedFeature
  );
  const [features, setFeatures] = useState<Feature[]>(props.features);

  /** Override default MuiBadge-anchor properties.
   * Default is `transform: scale(1) translate(50%, -50%)`
   */
  const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
      transform: `scale(1) translate(${
        props.numNotifications > 99 ? 35 : 40
      }%, -50%)`
    }
  }));

  //Hide resources tab when there are no resources
  const { learnerCollections } = useLearnerCollections();

  useEffect(() => {
    const noResources = learnerCollections?.length === 0;
    let copy = cloneDeep(props.features);
    //Filter 'Resources' if there is no resource collection.
    if (noResources) {
      copy = copy?.filter((c) => c.key !== 'resources');
    }
    setFeatures(copy);
  }, [JSON.stringify(props.features), learnerCollections]);

  useEffect(() => {
    setSelectedFeature(props.selectedFeature);
  }, [props.selectedFeature]);

  const handleChange = (event: ChangeEvent<{}>, newValue: FeatureKey) => {
    setSelectedFeature(newValue);
    if (isFunction(props.onNavigate)) {
      props.onNavigate(newValue);
    }
  };

  const numNotifications = props.numNotifications;

  return props.features ? (
    <Tabs
      variant="scrollable"
      indicatorColor="secondary"
      textColor="inherit"
      orientation={props.orientation}
      value={selectedFeature}
      onChange={handleChange}
    >
      {features?.map((f) => (
        <Tab
          key={f.key}
          label={
            f.key !== 'notifications' ? (
              f.name
            ) : (
              <StyledBadge
                badgeContent={props.numNotifications}
                color="primary"
                overlap="rectangular"
                invisible={numNotifications === 0}
              >
                {f.name}
              </StyledBadge>
            )
          }
          value={f.key}
        />
      ))}
    </Tabs>
  ) : null;
};

export default Navigation;
